module.exports = __webpack_public_path__ + "static/media/FastPacedActionCombat_MP4.e665b139.mp4";